import { Link } from 'react-router-dom';
import { articles } from '@/mocks/anime';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 8);

  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-50 font-heading mb-2">
              最新文章
            </h2>
            <p className="text-sm md:text-base text-foreground-400">
              第一时间获取国产动漫最新资讯与深度解读
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {latestArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-500/20 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full sm:w-48 h-36 sm:h-28 flex-shrink-0 rounded-md overflow-hidden">
                <div
                  className="absolute inset-0 bg-cover bg-center group-hover:scale-105 transition-transform duration-400"
                  style={{ backgroundImage: `url(${article.coverImage})` }}
                />
                {index < 3 && (
                  <div className="absolute top-2 left-2 w-5 h-5 flex items-center justify-center rounded bg-primary-500 text-background-50 text-xs font-bold">
                    {index + 1}
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-md">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.publishDate}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-2 mb-1.5">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 flex-wrap">
                  {article.tags.slice(0, 3).map((tag) => (
                    <span key={tag} className="text-xs text-foreground-600 bg-background-200/50 px-2 py-0.5 rounded">
                      #{tag}
                    </span>
                  ))}
                  <span className="text-xs text-foreground-500 ml-auto whitespace-nowrap">{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}